/* eslint-disable no-undef */
export const LocalStorageKeys = Object.freeze({
	SelectedCustomerId: "selectedCustomerId",
	CurrentObjectId: "currentObjectId",
	Language: "lang",
	Translations: "translations",
	SelectedTimeZone: "selectedTimeZone",
	LogoutTriggeredFromPortal: "logoutTriggeredFromPortal",
	SelectedCourseLanguages: "selectedCourseLanguages",
	SelectedCourseLevels: "selectedCourseLevels",
	SelectedUserCourseLevels: "selectedUserCourseLevels",
	SelectedCourseTrainings: "selectedCourseTrainings",
	SelectedRole: "selectedRole",
	EducationSelectedRole: "educationSelectedRole",
	CourseFilter: "courseFilter",
	Provider: "provider",
	LoginFirstRedirectHasBeenMade: "loginFirstRedirectHasBeenMade",
	Collapsed: "collapsed",
	IsMobileApp: "isMobileApp",
	ShowNonZero: "showNonZero",
	DashboardStatusSort: "dashboardStatusSort",
	DashboardActionSort: "dashboardActionSort"
})

export function setDashboardStatusSort(enable: boolean) {
	window.localStorage.setItem(LocalStorageKeys.DashboardStatusSort, enable.toString());
}

export function getDashboardStatusSort() {
	return window.localStorage.getItem(LocalStorageKeys.DashboardStatusSort) ? window.localStorage.getItem(LocalStorageKeys.DashboardStatusSort) === "true" : true;
}

export function setDashboardActionSort(sort: string) {
	window.localStorage.setItem(LocalStorageKeys.DashboardActionSort, sort);
}

export function getDashboardActionSort() {
	return window.localStorage.getItem(LocalStorageKeys.DashboardActionSort);
}

export function setSelectedCustomerId(customerId: string) {
	window.localStorage.setItem(LocalStorageKeys.SelectedCustomerId, customerId)
}

export function removeSelectedCustomerId() {
	window.localStorage.removeItem(LocalStorageKeys.SelectedCustomerId)
}

export function getSelectedCustomerId(): string {
	return window.localStorage.getItem(LocalStorageKeys.SelectedCustomerId)
}

export function setCurrentObjectId(objectId: string) {
	window.localStorage.setItem(LocalStorageKeys.CurrentObjectId, objectId)
}

export function getCurrentObjectId(): string {
	return window.localStorage.getItem(LocalStorageKeys.CurrentObjectId)
}

export function removeCurrentObjectId() {
	window.localStorage.removeItem(LocalStorageKeys.CurrentObjectId)
}

export function setLanguage(lang: string) {
	window.localStorage.setItem(LocalStorageKeys.Language, lang)
}

export function removeLanguage() {
	window.localStorage.removeItem(LocalStorageKeys.Language)
}

export function getLanguage(): string {
	return window.localStorage.getItem(LocalStorageKeys.Language)
}

export function setTranslations(translations: Record<string, string>) {
	window.localStorage.setItem(LocalStorageKeys.Translations, translations)
}

export function removeTranslations() {
	window.localStorage.removeItem(LocalStorageKeys.Translations)
}

export function getTranslations(): any {
	return window.localStorage.getItem(LocalStorageKeys.Translations)
}

export function setCollapsed(collapsed: boolean) {
	window.localStorage.setItem(LocalStorageKeys.Collapsed, collapsed.toString())
}

export function getCollapsed(): boolean {
	return window.localStorage.getItem(LocalStorageKeys.Collapsed) === "true"
}

export function setIsMobileApp(isMobileApp: boolean) {
	window.localStorage.setItem(LocalStorageKeys.IsMobileApp, isMobileApp.toString())
}

export function getIsMobileApp(): boolean {
	return window.localStorage.getItem(LocalStorageKeys.IsMobileApp) === "true"
}

export function setShowNonZero(showNonZero: boolean) {
	window.localStorage.setItem(LocalStorageKeys.ShowNonZero, showNonZero.toString())
}

export function getShowNonZero(): boolean {
	return window.localStorage.getItem(LocalStorageKeys.ShowNonZero) === "true"
}

export function setSelectedTimeZone(selectedTimeZone: string) {
	window.localStorage.setItem(LocalStorageKeys.SelectedTimeZone, selectedTimeZone)
}

export function removeSelectedTimeZone() {
	window.localStorage.removeItem(LocalStorageKeys.SelectedTimeZone)
}

export function getSelectedTimeZone(): string {
	return window.localStorage.getItem(LocalStorageKeys.SelectedTimeZone)
}

export function setLogoutTriggeredFromPortal(loginTriggeredFromPortal: boolean) {
	return window.localStorage.setItem(LocalStorageKeys.LogoutTriggeredFromPortal, loginTriggeredFromPortal.toString())
}

export function removeLogoutTriggeredFromPortal() {
	window.localStorage.removeItem(LocalStorageKeys.LogoutTriggeredFromPortal)
}

export function getLogoutTriggeredFromPortal(): boolean {
	return window.localStorage.getItem(LocalStorageKeys.LogoutTriggeredFromPortal) === "true" || false
}

export function setSelectedCourseLanguages(value: string) {
	window.localStorage.setItem(LocalStorageKeys.SelectedCourseLanguages, value)
}
export function getSelectedCourseLanguages() {
	return window.localStorage.getItem(LocalStorageKeys.SelectedCourseLanguages)
}
export function setSelectedRole(value: string) {
	window.localStorage.setItem(LocalStorageKeys.SelectedRole, value)
}
export function getSelectedRole() {
	return window.localStorage.getItem(LocalStorageKeys.SelectedRole)
}
export function setEducationSelectedRole(value: string) {
	window.localStorage.setItem(LocalStorageKeys.EducationSelectedRole, value)
}
export function getEducationSelectedRole() {
	return window.localStorage.getItem(LocalStorageKeys.EducationSelectedRole)
}
export function setSelectedCourseLevels(value: string) {
	window.localStorage.setItem(LocalStorageKeys.SelectedCourseLevels, value)
}
export function getSelectedCourseLevels() {
	return window.localStorage.getItem(LocalStorageKeys.SelectedCourseLevels)
}
export function setSelectedUserCourseLevels(value: string) {
	window.localStorage.setItem(LocalStorageKeys.SelectedUserCourseLevels, value)
}
export function getSelectedUserCourseLevels() {
	return window.localStorage.getItem(LocalStorageKeys.SelectedUserCourseLevels)
}
export function setSelectedCourseTrainings(value: string) {
	window.localStorage.setItem(LocalStorageKeys.SelectedCourseTrainings, value)
}
export function getSelectedCourseTrainings() {
	return window.localStorage.getItem(LocalStorageKeys.SelectedCourseTrainings)
}
export function setCourseFilter(value: string) {
	window.localStorage.setItem(LocalStorageKeys.SelectedCourseLanguages, value)
}
export function getCourseFilter() {
	return window.localStorage.getItem(LocalStorageKeys.SelectedCourseLanguages)
}

export function clearNonPersistentItems() {
	const lang = getLanguage()
	const timeZone = getSelectedTimeZone()
	const selectedCustomerId = getSelectedCustomerId()
	const logoutTriggeredFromPortal = getLogoutTriggeredFromPortal()
	const translations = getTranslations()
	const selectedCourseLanguages = getSelectedCourseLanguages()
	const selectedCourseLevels = getSelectedCourseLevels()
	const selectedUserCourseLevels = getSelectedUserCourseLevels()
	const selectedCourseTrainings = getSelectedCourseTrainings()
	const selectedRole = getSelectedRole()
	const educationSelectedRole = getEducationSelectedRole()
	const collapsed = getCollapsed()
	const isMobileApp = getIsMobileApp()
	const showNonZero = getShowNonZero()

	window.localStorage.clear()

	if (lang) {
		setLanguage(lang)
	}
	if (translations) {
		setTranslations(translations)
	}
	if (timeZone) {
		setSelectedTimeZone(timeZone)
	}
	if (selectedCustomerId) {
		setSelectedCustomerId(selectedCustomerId)
	}
	if (logoutTriggeredFromPortal) {
		setLogoutTriggeredFromPortal(logoutTriggeredFromPortal)
	}
	if (selectedCourseLanguages) {
		setSelectedCourseLanguages(selectedCourseLanguages)
	}
	if (selectedRole) {
		setSelectedRole(selectedRole)
	}
	if (educationSelectedRole) {
		setEducationSelectedRole(educationSelectedRole)
	}
	if (selectedCourseLevels) {
		setSelectedCourseLevels(selectedCourseLevels)
	}
	if (selectedUserCourseLevels) {
		setSelectedUserCourseLevels(selectedUserCourseLevels)
	}
	if (selectedCourseTrainings) {
		setSelectedCourseTrainings(selectedCourseTrainings)
	}
	if (collapsed !== null) {
		setCollapsed(collapsed)
	}
	if (isMobileApp !== null) {
		setIsMobileApp(isMobileApp)
	}
	if (showNonZero !== null) {
		setShowNonZero(showNonZero)
	}
}
